import { useState, useCallback, useEffect } from 'react';
import { useFormik } from 'formik';
import useToastNotification from 'hooks/useToastNotification';
import { getAccountTitleMSTDetail, saveAccountTitleMSTDetail } from 'api/accountTitleMST';
import AccountTitleMSTItemDomain from 'domain/master/general/accountTitleMSTItem';
import { useHistory } from 'react-router-dom';


export const useAccountTitleMSTDomainForm = (accountTitleId?: string) => {
  const [detailMode, setDetailMode] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();

  // modal confirm
  const [toastModalOpen, setToastModalOpen] = useState(false);

  // Modal alert
  const { successNotification, errorNotification } = useToastNotification();
  const onSubmit = async (values: AccountTitleMSTItemDomain) => {
    if (values.accountTitleCode === null) {
      errorNotification('画面　項目コード設定値');
      return false;
    }
    if (values.accountTitleName === null) {
      errorNotification('画面　項目名設定値');
      return false;
    }

    if (!confirmModalOpen) {
      setConfirmModalOpen(true);
    } else {
      try {
        const response = await saveAccountTitleMSTDetail(
          String(accountTitleId), values.getRawData(),
        );
        if (!response.errors) {
          setConfirmModalOpen(false);
          let successMes = '登録しました。';
          if (accountTitleId && accountTitleId !== 'undefined') {
            successMes = '更新しました。';
          }
          successNotification(successMes);
          history.push('/accountTitleMst');
        }
      } catch (error) {
        setConfirmModalOpen(false);
        if (error.response && error.response.data && error.response.data.length) {
          const listErr = error.response.data;
          let stringErr = '';
          listErr.map((element: any) => {
            stringErr += `${element.defaultMessage} \n`;
            return stringErr;
          });
          errorNotification(stringErr);
        } else {
          errorNotification('サーバー側でエラーが発生しました。');
          throw error;
        }
      }
    }
    return false;
  };

  const formik = useFormik({
    initialValues: AccountTitleMSTItemDomain.generateInitial(),
    validationSchema: false,
    onSubmit,
  });

  useEffect(() => {
    if (accountTitleId) {
      getAccountTitleMSTDetail(accountTitleId).then((response: any) => {
        if (response) {
          formik.setValues(new AccountTitleMSTItemDomain(response));
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountTitleId]);


  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  return {
    formik,
    detailMode,
    setDetailMode,
    confirmModalOpen,
    closeConfirmModal,
    toastModalOpen,
    setToastModalOpen,
  };
};

export default {
  useAccountTitleMSTDomainForm,
};
